module.exports = ".books-filter{margin-top:auto;margin-bottom:6px}\n"